// Generated from record-label-agreement.json at 2025-04-22T03:49:58.366Z
import { DocMap, FieldsMap } from "./";
import hourglass from "../../assets/hourglass-01.svg";

const creedSummaryFieldsMap: FieldsMap = {
  keyPoints: {
    name: "keyPoints",
    label: "Key Points",
    required: false,
    type: "text",
    subfields: [
      {
        name: "dealType",
        label: "Deal Type",
        required: false,
        type: "text",
      },
    ],
  },
  commitments: {
    name: "commitments",
    label: "Commitments",
    required: false,
    type: "text",
    subfields: [
      {
        name: "commitmentSummary",
        label: "Commitment Summary",
        required: false,
        type: "text",
      },
    ],
  },
};

const creedDataFieldsMap: FieldsMap = {
  artist: {
    name: "artist",
    label: "Artist",
    required: false,
    type: "text",
  },

  recordLabel: {
    name: "recordLabel",
    label: "Record Label",
    required: false,
    type: "text",
  },

  startDate: {
    name: "startDate",
    label: "Start Date",
    required: false,
    type: "date",
  },

  endDate: {
    name: "endDate",
    label: "End Date",
    required: false,
    type: "date",
  },

  artistRoyalties: {
    name: "artistRoyalties",
    label: "Artist Royalties",
    required: false,
    type: "array",
    subfields: [
      {
        name: "rate",
        label: "Rate",
        required: false,
        type: "number",
      },
      {
        name: "album",
        label: "Album",
        required: false,
        type: "text",
      },
      {
        name: "territory",
        label: "Territory",
        required: false,
        type: "text",
      },
      {
        name: "conditions",
        label: "Conditions",
        required: false,
        type: "array",
        subfields: [
          {
            name: "condition",
            label: "Condition",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  territory: {
    name: "territory",
    label: "Territory",
    required: false,
    type: "text",
  },

  termDuration: {
    name: "termDuration",
    label: "Term Duration",
    required: false,
    type: "text",
  },

  advances: {
    name: "advances",
    label: "Advances",
    required: false,
    type: "array",
    subfields: [
      {
        name: "amount",
        label: "Amount",
        required: false,
        type: "number",
      },
      {
        name: "trigger",
        label: "Trigger",
        required: false,
        type: "text",
      },
      {
        name: "recoupable",
        label: "Recoupable",
        required: false,
        type: "boolean",
      },
      {
        name: "recoupForm",
        label: "Recoup Form",
        required: false,
        type: "array",
        subfields: [
          {
            name: "recoupForm",
            label: "Recoup Form",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  commitments: {
    name: "commitments",
    label: "Commitments",
    required: false,
    type: "array",
    subfields: [
      {
        name: "albums",
        label: "Albums",
        required: false,
        type: "number",
      },
      {
        name: "requirements",
        label: "Requirements",
        required: false,
        type: "array",
        subfields: [
          {
            name: "requirement",
            label: "Requirement",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "timeline",
        label: "Timeline",
        required: false,
        type: "array",
        subfields: [
          {
            name: "timeline",
            label: "Timeline",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "isOptional",
        label: "Is Optional",
        required: false,
        type: "boolean",
      },
      {
        name: "option",
        label: "Option",
        required: false,
        type: "text",
      },
    ],
  },

  optionPeriods: {
    name: "optionPeriods",
    label: "Option Periods",
    required: false,
    type: "array",
    subfields: [
      {
        name: "exerciseMethod",
        label: "Exercise Method",
        required: false,
        type: "text",
      },
      {
        name: "termChanges",
        label: "Term Changes",
        required: false,
        type: "array",
        subfields: [
          {
            name: "termChange",
            label: "Term Change",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  maxOptionsDuration: {
    name: "maxOptionsDuration",
    label: "Max Options Duration",
    required: false,
    type: "text",
  },

  masterOwnership: {
    name: "masterOwnership",
    label: "Master Ownership",
    required: false,
    type: "array",
    subfields: [
      {
        name: "owner",
        label: "Owner",
        required: false,
        type: "text",
      },
      {
        name: "duration",
        label: "Duration",
        required: false,
        type: "text",
      },
      {
        name: "reversion",
        label: "Reversion",
        required: false,
        type: "array",
        subfields: [
          {
            name: "reversion",
            label: "Reversion",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "restrictions",
        label: "Restrictions",
        required: false,
        type: "array",
        subfields: [
          {
            name: "restriction",
            label: "Restriction",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  distributionRights: {
    name: "distributionRights",
    label: "Distribution Rights",
    required: false,
    type: "array",
    subfields: [
      {
        name: "physical",
        label: "Physical",
        required: false,
        type: "array",
        subfields: [
          {
            name: "physical",
            label: "Physical",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "digital",
        label: "Digital",
        required: false,
        type: "array",
        subfields: [
          {
            name: "digital",
            label: "Digital",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "limitations",
        label: "Limitations",
        required: false,
        type: "array",
        subfields: [
          {
            name: "limitation",
            label: "Limitation",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "exclusions",
        label: "Exclusions",
        required: false,
        type: "array",
        subfields: [
          {
            name: "exclusion",
            label: "Exclusion",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  accounting: {
    name: "accounting",
    label: "Accounting",
    required: false,
    type: "array",
    subfields: [
      {
        name: "frequency",
        label: "Frequency",
        required: false,
        type: "array",
        subfields: [
          {
            name: "frequency",
            label: "Frequency",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "auditRights",
        label: "Audit Rights",
        required: false,
        type: "array",
        subfields: [
          {
            name: "auditRight",
            label: "Audit Right",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "timeLimit",
        label: "Time Limit",
        required: false,
        type: "array",
        subfields: [
          {
            name: "timeLimit",
            label: "Time Limit",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "resolutionProcess",
        label: "Resolution Process",
        required: false,
        type: "array",
        subfields: [
          {
            name: "resolutionProces",
            label: "Resolution Proces",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  exclusivityTerms: {
    name: "exclusivityTerms",
    label: "Exclusivity Terms",
    required: false,
    type: "array",
    subfields: [
      {
        name: "isExclusive",
        label: "Is Exclusive",
        required: false,
        type: "boolean",
      },
      {
        name: "scope",
        label: "Scope",
        required: false,
        type: "array",
        subfields: [
          {
            name: "scope",
            label: "Scope",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "exceptions",
        label: "Exceptions",
        required: false,
        type: "array",
        subfields: [
          {
            name: "exception",
            label: "Exception",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "limitations",
        label: "Limitations",
        required: false,
        type: "array",
        subfields: [
          {
            name: "limitation",
            label: "Limitation",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  recordingBudget: {
    name: "recordingBudget",
    label: "Recording Budget",
    required: false,
    type: "array",
    subfields: [
      {
        name: "item",
        label: "Item",
        required: false,
        type: "text",
      },
      {
        name: "amount",
        label: "Amount",
        required: false,
        type: "number",
      },
      {
        name: "control",
        label: "Control",
        required: false,
        type: "text",
      },
      {
        name: "recoupable",
        label: "Recoupable",
        required: false,
        type: "boolean",
      },
      {
        name: "overages",
        label: "Overages",
        required: false,
        type: "array",
        subfields: [
          {
            name: "overage",
            label: "Overage",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },
};

export const CreedRecordLabelAgreementMap: DocMap = {
  summaryFields: creedSummaryFieldsMap,
  dataFields: creedDataFieldsMap,
  entityHrefTitle: () => "Coming soon...",
  entityHrefIcon: () => hourglass,
  entityHrefSubtitle: () => "",
  entityHref: null,
};
